export default __webpack_public_path__ + "static/media/panbesy-censored.ac03e8b6.png";